import { SurveyView } from "uikit"
import { ReactComponent as CheckCircleOutlineIcon } from "uikit/Icons/checkcircleoutline.svg"
import { ReactComponent as NotConfidentIcon } from "uikit/Icons/not-confident.svg"
import { ReactComponent as SlightlyConfidentIcon } from "uikit/Icons/slightly-confident.svg"
import { ReactComponent as SomeWhatConfidentIcon } from "uikit/Icons/somewhat-confident.svg"
import { ReactComponent as ModeratelyConfidentIcon } from "uikit/Icons/moderately-confident.svg"
import { ReactComponent as VeryConfidentIcon } from "uikit/Icons/very-confident.svg"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Button, Container, Grid, Modal } from "semantic-ui-react"
import "./SurveyPoll.css"
import { useStore } from "store"

const SURVEY_OPTIONS = {
  "not-at-all": {
    label: "Not Confident",
    value: "not-at-all"
  },
  slightly: {
    label: "Slightly Confident",
    value: "slightly"
  },
  somewhat: {
    label: "Somewhat Confident",
    value: "somewhat"
  },
  moderately: {
    label: "Moderately Confident",
    value: "moderately"
  },
  very: {
    label: "Very Confident",
    value: "very"
  }
}

const getOptionIcon = (name, isDisabled) => {
  let iconClass = "surveyIcon"
  if (isDisabled) {
    iconClass += " disabled"
  }
  switch (name) {
    case "not-at-all":
      return <NotConfidentIcon className={iconClass} />
    case "slightly":
      return <SlightlyConfidentIcon className={iconClass} />
    case "somewhat":
      return <SomeWhatConfidentIcon className={iconClass} />
    case "moderately":
      return <ModeratelyConfidentIcon className={iconClass} />
    case "very":
      return <VeryConfidentIcon className={iconClass} />
    default:
      break
  }
}

const getPollResponse = (selectedPoll, continueUrl) => {
  switch (selectedPoll) {
    case "not-at-all":
      return (
        <NotConfidentPollResponse
          selectedPoll={selectedPoll}
          continueUrl={continueUrl}
        />
      )
    case "slightly":
      return (
        <SlightlyConfidentPollResponse
          selectedPoll={selectedPoll}
          continueUrl={continueUrl}
        />
      )
    case "somewhat":
      return (
        <SomewhatConfidentPollResponse
          selectedPoll={selectedPoll}
          continueUrl={continueUrl}
        />
      )
    case "moderately":
      return (
        <ModeratelyConfidentPollResponse
          selectedPoll={selectedPoll}
          continueUrl={continueUrl}
        />
      )
    case "very":
      return (
        <VeryConfidentPollResponse
          selectedPoll={selectedPoll}
          continueUrl={continueUrl}
        />
      )
    default:
      break
  }
}
export const SurveyPoll = props => {
  const [isResponseCompleted, toggleIsResponseComplete] = useState(false)
  const [selectedPoll, chanegSelectedPoll] = useState("")
  const { addPoll } = useStore()

  if (isResponseCompleted) {
    return getPollResponse(selectedPoll, props.continueUrl)
  }
  return (
    <Container textAlign="center" className="AccountIntroduction">
      <Grid centered style={{ padding: "10px" }}>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <SurveyView
              question="How confident are you that you're doing what's needed to meet your longer term financial goals?"
              description="There are no wrong answers. SAVVI can improve your confidence and help you make financial progress."
              responseOptions={SURVEY_OPTIONS}
              onSelectResponse={async selectedOption => {
                await addPoll({
                  household_id: props.household.id,
                  option: selectedOption
                })
                chanegSelectedPoll(selectedOption)
                toggleIsResponseComplete(true)
              }}
              onGetOptionIcon={name => {
                return getOptionIcon(name, true)
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  )
}

export const SurveyPollModal = props => {
  const [isResponseCompleted, toggleIsResponseComplete] = useState(false)
  const { addPoll } = useStore()

  return (
    <Modal
      open={!isResponseCompleted}
      onClose={() => toggleIsResponseComplete(true)}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      style={{ minHeight: "20em" }}
    >
      <Modal.Content>
        <Grid className="white">
          <Grid.Row style={{ borderBottom: "1px solid #cccccc" }}>
            <Grid.Column>
              <SurveyView
                question="How confident are you that you're doing what's needed to meet your longer term financial goals?"
                description="There are no wrong answers. SAVVI can improve your confidence and help you make financial progress."
                responseOptions={SURVEY_OPTIONS}
                onSelectResponse={async selectedOption => {
                  await addPoll({
                    household_id: props.household.id,
                    option: selectedOption
                  })
                  toggleIsResponseComplete(true)
                  props.onClose()
                }}
                onGetOptionIcon={name => {
                  return getOptionIcon(name, true)
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  )
}

const NotConfidentPollResponse = ({ selectedPoll, continueUrl }) => (
  <Container textAlign="center" className="AccountIntroduction">
    <Grid centered className="Survey_ResponseDiv">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div>
            {getOptionIcon(selectedPoll)}
            <p className="Response_Title">Not confident is not permanent!</p>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <p>
            You're not alone if you feel unsure about your financial future.
            We'll help you establish a plan that will give you the confidence
            you need to make progress towards your goals. Did you know that
            people with a plan are:
          </p>
          <div>
            <ul className="Survey__ListType">
              <li style={{ marginBottom: "10px" }}>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  <span>
                    {" "}
                    3x more likely to be satisfied with personal finances
                    <a
                      href="http://www.usfinancialcapability.org/downloads/NFCS_2015_Report_Natl_Findings.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <sup>*</sup>
                    </a>{" "}
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  2x more likely to be living comfortably
                  <a
                    href="https://www.cfp.net/docs/news-events---research-facts-figures/2012_household_financial_planning_survey.pdf?sfvrsn=2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <sup>*</sup>
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <p style={{ marginTop: "30px" }}>
            It all starts with getting organized.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={14} textAlign="center">
          <div>
            <Link to={continueUrl} className="navlink">
              <Button
                primary
                size="big"
                data-testid="continue"
                className="Response_Button"
              >
                Continue
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
)
const SlightlyConfidentPollResponse = ({ selectedPoll, continueUrl }) => (
  <Container textAlign="center" className="AccountIntroduction">
    <Grid centered className="Survey_ResponseDiv">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div>
            {getOptionIcon(selectedPoll)}
            <p className="Response_Title">
              Slightly confident can grow by taking action!
            </p>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <p>
            The giant sequoia grows from a pinhead-sized seed and so can your
            confidence! Did you know that people with a plan are:
          </p>
          <div>
            <ul className="Survey__ListType">
              <li style={{ marginBottom: "10px" }}>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  <span>
                    {" "}
                    3x more likely to be satisfied with personal finances
                    <a
                      href="http://www.usfinancialcapability.org/downloads/NFCS_2015_Report_Natl_Findings.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <sup>*</sup>
                    </a>{" "}
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  2x more likely to be living comfortably
                  <a
                    href="https://www.cfp.net/docs/news-events---research-facts-figures/2012_household_financial_planning_survey.pdf?sfvrsn=2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <sup>*</sup>
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <p style={{ marginTop: "30px" }}>
            It all starts with getting organized.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={14} textAlign="center">
          <div>
            <Link to={continueUrl} className="navlink">
              <Button
                primary
                size="big"
                data-testid="continue"
                className="Response_Button"
              >
                Continue
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
)

const SomewhatConfidentPollResponse = ({ selectedPoll, continueUrl }) => (
  <Container textAlign="center" className="AccountIntroduction">
    <Grid centered className="Survey_ResponseDiv">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div>
            {getOptionIcon(selectedPoll)}
            <p className="Response_Title">
              Somewhat confident is a great start!
            </p>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <p>
            We can give your confidence just the boost it needs by helping you
            navigate those complex financial decisions that nag at you. Did you
            know that people with a plan are:
          </p>
          <div>
            <ul className="Survey__ListType">
              <li style={{ marginBottom: "10px" }}>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  <span>
                    {" "}
                    3x more likely to be satisfied with personal finances
                    <a
                      href="http://www.usfinancialcapability.org/downloads/NFCS_2015_Report_Natl_Findings.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <sup>*</sup>
                    </a>{" "}
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  2x more likely to be living comfortably
                  <a
                    href="https://www.cfp.net/docs/news-events---research-facts-figures/2012_household_financial_planning_survey.pdf?sfvrsn=2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <sup>*</sup>
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <p style={{ marginTop: "30px" }}>
            It all starts with getting organized.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={14} textAlign="center">
          <div>
            <Link to={continueUrl} className="navlink">
              <Button
                primary
                size="big"
                data-testid="continue"
                className="Response_Button"
              >
                Continue
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
)

const ModeratelyConfidentPollResponse = ({ selectedPoll, continueUrl }) => (
  <Container textAlign="center" className="AccountIntroduction">
    <Grid centered className="Survey_ResponseDiv">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div>
            {getOptionIcon(selectedPoll)}
            <p className="Response_Title">
              Moderately confident is a fantastic foundation!
            </p>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <p>
            We can help you maintain and strengthen that confidence by
            uncovering hidden opportunities and avoiding unseen trouble. Did you
            know that people with a plan are:
          </p>
          <div>
            <ul className="Survey__ListType">
              <li style={{ marginBottom: "10px" }}>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  <span>
                    {" "}
                    3x more likely to be satisfied with personal finances
                    <a
                      href="http://www.usfinancialcapability.org/downloads/NFCS_2015_Report_Natl_Findings.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <sup>*</sup>
                    </a>{" "}
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  2x more likely to be living comfortably
                  <a
                    href="https://www.cfp.net/docs/news-events---research-facts-figures/2012_household_financial_planning_survey.pdf?sfvrsn=2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <sup>*</sup>
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <p style={{ marginTop: "30px" }}>
            It all starts with getting organized.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={14} textAlign="center">
          <div>
            <Link to={continueUrl} className="navlink">
              <Button
                primary
                size="big"
                data-testid="continue"
                className="Response_Button"
              >
                Continue
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
)

const VeryConfidentPollResponse = ({ selectedPoll, continueUrl }) => (
  <Container textAlign="center" className="AccountIntroduction">
    <Grid centered className="Survey_ResponseDiv">
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div>
            {getOptionIcon(selectedPoll)}
            <p className="Response_Title">Ok, money mouth!</p>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <p>
            You're in a fantastic place, let's keep you there! We can help you
            uncover hidden opportunities and avoid unseen trouble that could
            derail your hard-earned confidence. Did you know that people with a
            plan are:
          </p>
          <div>
            <ul className="Survey__ListType">
              <li style={{ marginBottom: "10px" }}>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  <span>
                    {" "}
                    3x more likely to be satisfied with personal finances
                    <a
                      href="http://www.usfinancialcapability.org/downloads/NFCS_2015_Report_Natl_Findings.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <sup>*</sup>
                    </a>{" "}
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <CheckCircleOutlineIcon className="Survey_ListIcon" />
                  2x more likely to be living comfortably
                  <a
                    href="https://www.cfp.net/docs/news-events---research-facts-figures/2012_household_financial_planning_survey.pdf?sfvrsn=2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <sup>*</sup>
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <p style={{ marginTop: "30px" }}>
            It all starts with getting organized.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={14} textAlign="center">
          <div>
            <Link to={continueUrl} className="navlink">
              <Button
                primary
                size="big"
                data-testid="continue"
                className="Response_Button"
              >
                Continue
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
)
